import { FormDataPost, Get, Patch, Post, Put, getAPIUrl } from "./apiMethod";
import { Authendpoint, Globalendpoints } from "./global";

export const userLogin = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.Login, param);
  return Post(url, data, false);
};

export const userLogout = (data, param = "") => {
  const url = getAPIUrl(Authendpoint.logout, param);
  return Post(url, data, false);
};
export const getDashboardData = (param = "") => {
  const url = getAPIUrl(Globalendpoints.dashboardCount, param);
  return Get(url);
};
export const addBank = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.addBankDetail, param);
  return FormDataPost(url, data);
};
export const updateBank = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updateBankDetail, param);
  return Put(url, data);
};
export const fetchBank = (param = "") => {
  const url = getAPIUrl(Globalendpoints.fetchBankDetail, param);
  return Get(url);
};
export const fetchFundReq = (param = "") => {
  const url = getAPIUrl(Globalendpoints.fetchFundReq, param);
  return Get(url);
};
export const fundReqAction = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.fundReqAction, param);
  return Put(url, data);
};
export const getWithdrawalReq = (param = "") => {
  const url = getAPIUrl(Globalendpoints.fetchWithdrawalReq, param);
  return Get(url);
};
export const updateWithdrawalReq = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updateWithdrawalReq, param);
  return Put(url, data);
};


export const GetUserList = (param = "") => {
  const url = getAPIUrl(Globalendpoints.userList, param);
  return Get(url);
};

export const UpdateUser = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updateUser, param);
  return Patch(url, data);
};
export const GetUserBettings = (param = "") => {
  const url = getAPIUrl(Globalendpoints.userBettings, param);
  return Get(url);
};
export const GetUserWalletTxn = (param = "") => {
  const url = getAPIUrl(Globalendpoints.walletTxn, param);
  return Get(url);
};

export const GetPaymentSetting = (param = "") => {
  const url = getAPIUrl(Globalendpoints.getPaymentSetting, param);
  return Get(url);
};

export const updatePaymentSetting = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.updatePaymentSetting, param);
  return Put(url, data);
};

export const passwordChange = (data, param = "") => {
  const url = getAPIUrl(Globalendpoints.changePassword, param);
  return Put(url, data);
};

// number (matka) game apis

export const getNumberRooms = (param = "") => {
  const url = getAPIUrl(Globalendpoints.numberRooms, param);
  return Get(url);
};
export const getNumberRoomDetail = (roomId, param = "") => {
  const url = getAPIUrl(`${Globalendpoints.numberRoomDetail}${roomId}`, param);
  return Get(url);
};
export const declareNumberResult = (roomId, data, param = "") => {
  const url = getAPIUrl(
    `${Globalendpoints.numberDeclareResult}${roomId}`,
    param
  );
  return Post(url, data);
};

// COMISSION SETTING

export const getCommisionSetting = (param = "") => {
  const url = getAPIUrl(Globalendpoints.fetchComissionSetting, param);
  return Get(url);
};


export const updateCommisionSetting = (data,param = "") => {
  const url = getAPIUrl(Globalendpoints.updateReferalComm, param);
  return Put(url,data);
};